//@flow
import * as React from 'react';
import {baseClass} from "../../../../pages/UiKit/newUiKit/utilities/baseClass";
import type {id} from "../../../../services/flowTypes/appFlowTypes";
import type {addClasses} from "../../../../services/flowTypes/uiKitFlowTypes";
import './LoadingIcon.css';

type Props = {
  id?: id,
  addClasses?: addClasses
};

const LoadingIcon = (props: Props) => {
  return (
    <div id={props.id} className={baseClass("LoadingIcon", props.addClasses)}/>
  );
};

export default LoadingIcon;